import * as angular from "angular";

angular
  .module('bringoz.admin.shippers', [
    'bringoz.admin.accounts'
  ]);
